import React from 'react'
import {LoggerProps, withLogger} from './withLogger'
import {withPageTitle} from './withPageTitle'
import {withScroller} from './withScroller'
import {withLoadingSpinner} from './withLoadingSpinner'
import EventEmitterExGuest from '../pageBaseComponents/EventEmitterExGuest'
import {RouterPageProps} from '../RouterPropsInjector'

export type GuestPagePropsSet =
    LoggerProps &
    RouterPageProps &
    { eventEmitter: EventEmitterExGuest }

export const createGuestPage = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps & GuestPagePropsSet>,
) =>
    withLogger(
        WrappedComponent.displayName || 'undefined',
        withScroller(
            withPageTitle(
                withLoadingSpinner(
                    WrappedComponent))),
    )
